import config from '@/config'
let $httpVue = null;
// 📌 模拟请求拦截器
class FetchInterceptor {
    constructor() {
        this.refreshing = false; // 标识 token 刷新状态
        this.subscribers = []; // 存储待处理的请求
        this.vueInstance = null; // 存储 Vue 组件实例
    }
   /**
     * 设置 Vue 组件实例（可选）
     */
    setVueInstance(vueInstance) {
        this.vueInstance = vueInstance;
    }
    // 请求拦截器
    async requestInterceptor(url, options) {
        let accessToken = this.vueInstance.$store.getters.getToken();
        if (!options.headers) {
            options.headers = {};
        }
        // 在请求头中添加 Authorization
        options.headers["Authorization"] = `${accessToken}`;
        return { url, options };
    }

    // 响应拦截器
    async responseInterceptor(response, url, options) {
        if (response.status === 401 && !this.refreshing) {
            // 如果 token 失效且没有正在刷新
            console.log("Access token expired, attempting to refresh...");
            this.refreshing = true;
            const newAccessreslut= await this.refreshToken();

            if (newAccessreslut) {
                // 更新本地存储的 token
                this.vueInstance.$store.commit('setUserInfo', newAccessreslut);
                // 通知所有挂起的请求
                this.subscribers.forEach((callback) => callback(newAccessreslut.accessToken));
                this.subscribers = [];

                // 重新发送原始请求
                options.headers["Authorization"] = `Bearer ${newAccessreslut.accessToken}`;
                response = await fetch(url, options);
            } else {
                console.error("Refresh token invalid. Redirecting to login...");
                this.vueInstance.$store.commit('clearUserInfo');
                this.vueInstance.$router.push({ path: '/login', params: { r: Math.random() } });
                // 跳转到登录页面
               // window.location.href = "/login";
            }
        }
        return response;
    }

    // 刷新 token
    async refreshToken() {
        const refreshToken = this.vueInstance.$store.getters.getRefreshToken();
        if (!refreshToken) {
            console.error("No refresh token available.");
            return null;
        }

        try {
            const response = await fetch(`${config.baseUrl}api/AccessToken/Refresh`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({Token:refreshToken })
            });

            if (!response.ok) {
                throw new Error("Failed to refresh token");
            }

            const reslut = await response.json();
            return reslut.data;
        } catch (error) {
            console.error("Error refreshing token:", error);
            return null;
        }
    }

    // 向拦截器添加请求
    addSubscriber(callback) {
        this.subscribers.push(callback);
    }

    // 请求函数，支持 GET、POST 等方法
    async request(url, options = {}) {
        // 执行请求拦截器
        const { url: finalUrl, options: finalOptions } = await this.requestInterceptor(config.baseUrl+url, options);
        try {
            let response = await fetch(finalUrl, finalOptions);
            
            // 执行响应拦截器
            response = await this.responseInterceptor(response, finalUrl, finalOptions);

            // 如果返回是 JSON 格式
            if (response.ok) {
                const responseData = await response.json(); // 返回 JSON 格式的数据
                return { success: true, data: responseData };
            } else {
                return { success: false, status: response.status, message: `Request failed with status ${response.status}` };
            }
        } catch (error) {
            return { success: false, status: 500, message: error.message || "An unexpected error occurred." };
        }
    }

    // GET 请求
    async get(url, options = {}, vueInstance = null) {
        if (vueInstance) this.setVueInstance(vueInstance);
        options.method = 'GET';
        return this.request(url, options);
    }

    // POST 请求
    async post(url, body, options = {}, vueInstance = null) {
        if (vueInstance) this.setVueInstance(vueInstance);
        options.method = 'POST';
        options.body = JSON.stringify(body);
        options.headers = { ...options.headers, "Content-Type": "application/json" };
        return this.request(url, options);
    }

    // 支持流式读取响应
    async streamRequest(url, options = {}, vueInstance = null) {
        if (vueInstance) this.setVueInstance(vueInstance);
        // 执行请求拦截器
        const { url: finalUrl, options: finalOptions } = await this.requestInterceptor(config.baseUrl+url, options);
        try {
            const response = await fetch(finalUrl, finalOptions);
            // 执行响应拦截器
            const finalResponse = await this.responseInterceptor(response, finalUrl, finalOptions);
            if (!finalResponse.ok) {
                return { success: false, status: finalResponse.status, message: `Request failed with status ${finalResponse.status}` };
            }
            //使用 ReadableStream 进行流式处理
            return finalResponse.body.getReader();
        } catch (error) {
            return { success: false, status: 500, message: error.message || "Error while streaming response." };
        }
    }
}



export default new FetchInterceptor();


// WEBPACK FOOTER //
// ./src/api/fetchHttp.js